import React from "react";
import { useSolrContext } from "@e-fork/solr";
import useTranslate from "@default/hooks/use-translate";
import Status from "@default/general-components/status/status";
import LoadingIndicator from "@default/general-components/loading-indicator";

const Loading = () => {
  const { status } = useSolrContext();
  const _t = useTranslate();
  if (status === "IDLE") return;

  return <LoadingIndicator />;
};

export default Loading;
